module.exports = __webpack_public_path__ + "img/logosttrteofilotoni.d2ec7658.png";